<template>
	<div class="product-list">
		<template v-if="products.length == 0">
			<p v-if="context == 'appointment'" class="font-weight-thin ml-2" v-translate>No prescription.</p>
			<p v-if="context == 'settings'" class="font-weight-thin ml-2" v-translate>No products found.</p>
			<p
				v-if="context == 'new-product'"
				class="font-weight-thin ml-2"
				v-translate
			>No substances selected.</p>
		</template>
		<template v-else>
			<v-list flat>
				<div
					v-infinite-scroll="loadMore"
					infinite-scroll-disabled="loading"
					infinite-scroll-distance="0"
					v-if="infiniteScroll"
				>
					<ProductItem
						v-for="product in products"
						:product="product"
						:key="product.product.id"
						@remove-product="removeProduct"
						@edit-posology="editPosology"
						:type="type"
						:context="context"
						:admin="admin"
					/>
					<v-row class="mt-2" v-if="loading" no-gutters>
						<v-progress-linear
							:active="loading"
							:indeterminate="loading"
							top
							color="primary"
						></v-progress-linear>
					</v-row>
				</div>
				<ProductItem
					v-else
					v-for="product in products"
					:product="product"
					:key="product.product.id"
					@remove-product="removeProduct"
					@edit-posology="editPosology"
					:type="type"
					:context="context"
					:admin="admin"
				/>
			</v-list>
			<template v-if="context == 'appointment'">
				<v-btn v-if="type == 'supplement'" text small color="primary" @click="getSubstanceQuantities" :loading="loadingSubstanceQuantity">
					<translate>Extra Info</translate>
					<v-icon color="primary">mdi-chevron-down</v-icon>
				</v-btn>
				<v-row no-gutters v-if="showExtraInfo">
					<v-col cols="12" md="6">
						<v-simple-table>
							<template v-slot:default>
								<thead>
									<tr>
										<th class="text-left" v-translate>Substance</th>
										<th class="text-left" v-translate>Quantity</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(quantity, substance) in substanceQuantity" :key="substance">
										<td>{{ substance }}</td>
										<td align="right">{{ quantity.quantity }} <span class="font-weight-thin">{{ quantity.unit }}</span></td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</v-col>
				</v-row>
			</template>
		</template>
	</div>
</template>

<script>
import ProductItem from "@/components/products/ProductItem.vue";
import infiniteScroll from "vue-infinite-scroll";
import axios from "axios";

export default {
	name: "ProductList",
	props: ["products", "type", "context", "admin", "infiniteScroll"],
	components: {
		ProductItem
	},
	directives: {
		infiniteScroll
	},
	data: () => ({
		showExtraInfo: false,
		loading: false,
		over: false,
		substanceQuantity: [],
		loadingSubstanceQuantity: false
	}),
	methods: {
		removeProduct(product) {
			this.$emit("remove-product", product);
		},
		editPosology(product, frequency) {
			this.$emit("edit-posology", product, frequency);
		},
		loadMore() {
			if(!this.over) {
				this.loading = true;
				this.$emit('load-more');
			}
		},
		addProducts(products) {
			this.loading = false;
			if(products.length == 0) this.over = true;
			for(let i = 0; i < products.length; i++) {
        this.products.push(products[i]);
			}
		},
		getSubstanceQuantities() {
			if(!this.showExtraInfo) {
				this.loadingSubstanceQuantity = true;
				const appointmentId = this.$route.params.aid;
				const patientId = this.$route.params.aid;
				let link = '';
				if(this.type == 'formula') link = 'formulas_substance_quantity';
				else link = 'supplements_substance_quantity';
				axios
					.get(
						"/patient/" +
							patientId +
							"/appointment/" +
							appointmentId +
							"/" + link
					)
					.then(response => {
						if (response.status === 200) {
							console.log(response.data);
							this.substanceQuantity = response.data.substance_quantity;
							this.loadingSubstanceQuantity = false;
							this.showExtraInfo = true;
						}
					})
					.catch(error => console.log(error));
			} else {
				this.showExtraInfo = false;
			}
		}
	}
};
</script>

<style scoped>
.scroller {
	height: 100%;
}

.user {
	height: 32%;
	padding: 0 12px;
}
</style>